import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/app'
import * as serviceWorker from './serviceWorker'
import './styles/index.css'
import store from './store'
import { Provider } from 'react-redux'

const rootElement = document.getElementById('root')

if(rootElement.hasChildNodes()){
    ReactDOM.hydrate(
        <Provider store={store}>
            <App />
        </Provider>, rootElement
    )
} else {
    ReactDOM.render(
        <Provider store={store}>
            <App />
        </Provider>, rootElement
    )
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register()
